import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import configPrint from '../../../print-config.json'
import config from '../../../config.json'
import PrintTypeItem from './PrintTypeItem';
import Translation from '../../Translation/cont/Translation';
import AttributeColorSettingsForm from './AttributeColorSettingsForm';
import AddNewAttributeColorSelect from './AddNewAttributeColorSelect';

const ChoosePrintType = ({
    usedWebToPrintRoutes, 
    basicUrl,
    closePagePath,
    addItem,
    onUpdateItem,
    filteredTechnicals,
    attributeColorSettings,
    removeItem
}) => (
    <WrapperPageSimple 
        pageTitleTransId={config.routes.webtoprint.transId} 
        closePagePath={closePagePath}
    >
        <div className="print-page print-type site-content">
            {usedWebToPrintRoutes[0] ? usedWebToPrintRoutes.map((routeKey) => {
                const item = configPrint.routes[routeKey]
                const transIdname = item.transIdname
                const transIdDescription = item.transIdDescription
                const path = `${basicUrl}/${item.path}`

                return (
                    <PrintTypeItem 
                        key={routeKey} 
                        id={routeKey} 
                        transIdname={transIdname} 
                        path={path} 
                        transIdDescription={transIdDescription}
                    />
                )
            }) : (
                <div>Bitte kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com">Support</a></div>
            )}
        </div>

        {usedWebToPrintRoutes[0] && <div className='print-page print-attribute-content'>
            <div className='title-large-light'><Translation id={'route_web2print_attributes'}></Translation></div>
            <div className='label-description text-small-light gap-20'><Translation id={'route_web2print_attributes_hint'}></Translation></div>
            <AddNewAttributeColorSelect 
                attributeColorSettings={attributeColorSettings}
                filteredTechnicals={filteredTechnicals}
                addItem={addItem}
            /> 

            <AttributeColorSettingsForm
                attributeColorSettings={attributeColorSettings}
                onUpdateItem={onUpdateItem}
                removeItem={removeItem}
            />
        </div>}
    </WrapperPageSimple>
)

export default ChoosePrintType  